import { notification } from 'antd'
import axios from './axiosInstance'

import constants from '../constants'

export default async function appsPostOrDelete(app, updatedSettings, featureKey) {
  // for cards
  featureKey = `ai.${featureKey}`
  const apiUrl = `${constants.customerDomain}apps/${app.id}/features/${featureKey}/enabled`

  try {
    const ccBearerToken = localStorage.getItem('ccBearerToken')
    if (ccBearerToken) {
      if (updatedSettings.enabled) {
        const response = await axios.post(
          apiUrl,
          {},
          {
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              Authorization: `Bearer ${ccBearerToken}`,
            },
          },
        )
        return response?.data
      }

      if (!updatedSettings.enabled) {
        const response = await axios.delete(apiUrl, {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${ccBearerToken}`,
          },
        })
        return response?.data
      }
    }
  } catch (error) {
    return error.message
  }
  return false
}

export async function appsGetFeatures(app) {
  const apiUrl = `${constants.customerDomain}apps/${app.id}/ai/features`

  try {
    const ccBearerToken = localStorage.getItem('ccBearerToken')
    if (ccBearerToken) {
      const response = await axios.get(apiUrl, {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${ccBearerToken}`,
        },
      })
      return response?.data
    }
  } catch (error) {
    return error.message
  }
  return false
}
export async function appsGetSettings(app) {

  const apiUrl = `${constants.customerDomain}apps/${app.id}/ai/settings`

  try {
    const ccBearerToken = localStorage.getItem('ccBearerToken')
    if (ccBearerToken) {
      const response = await axios.get(apiUrl, {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${ccBearerToken}`,
        },
      })
      return response?.data
    }
  } catch (error) {
    return error.message
  }
  return false
}

export async function settingsUpdate(app, updatedSettings) {
  const apiUrl = `${constants.customerDomain}apps/${app.id}/ai/settings`

  try {
    const ccBearerToken = localStorage.getItem('ccBearerToken')
    if (ccBearerToken) {
      const response = await axios.put(apiUrl, updatedSettings, {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${ccBearerToken}`,
        },
      })
      // notification.success({
      //   message: response.data.data.message,
      //   placement: 'bottomRight',
      // })
      return response?.data
    }
  } catch (error) {
    notification.error({
      message: error.message,
      placement: 'bottomRight',
    })
    return error.message
  }
  return false
}



export async function settingsPostOrDelete(app, updatedSettings) {
  const featureKey = 'ai'
  const apiUrl = `${constants.customerDomain}apps/${app.id}/features/${featureKey}/enabled`

  try {
    const ccBearerToken = localStorage.getItem('ccBearerToken')
    if (ccBearerToken) {
      if (updatedSettings.enabled) {
        const response = await axios.post(
          apiUrl,
          {},
          {
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              Authorization: `Bearer ${ccBearerToken}`,
            },
          },
        )
        return response?.data
      }

      if (!updatedSettings.enabled) {
        const response = await axios.delete(apiUrl, {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${ccBearerToken}`,
          },
        })
        return response?.data
      }
    }
  } catch (error) {
    return error.message
  }
  return false
}
